import { Copy as CopyIcon } from 'iconoir-react'
import { Tooltip } from '../Tooltip'
import { useCopyToClipboard } from 'app/hooks/useCopyToClipboard'

export function CopyToClipboard({ text }: { text: string }) {
  const copyToClipboard = useCopyToClipboard()

  return text ? (
    <Tooltip message="Copy to clipboard" tooltipClassName="!left-4">
      <CopyIcon className="aspect-square h-full w-auto cursor-pointer" onClick={() => copyToClipboard(text)} />
    </Tooltip>
  ) : (
    <></>
  )
}
